import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

import {
  IActionProps,
  IError,
  IPageMeta,
  IProduct,
  IProductData,
} from "@/services/interfaces/";
import fetchPage from "@/services/api/product/";

import { personalModule } from "@/plugins/store-accessors";
import { newSaleChecker } from "@/services/api/utils/newSaleChecker";

// @TODO add interceptors for logout logic

@Module({
  name: "product",
  namespaced: true,
})
export default class ProductModule extends VuexModule {
  data: IProductData | null = null;
  meta: IPageMeta | null = null;
  error: IError | null = null;
  relatedProducts: IProduct[] = [];

  get getMeta() {
    return this.meta;
  }
  get getData() {
    return this.data;
  }
  get getError() {
    return this.error;
  }
  get getRelatedProducts() {
    return this.relatedProducts;
  }

  @Mutation
  SET_PAGE_DATA(data: IProductData | null) {
    this.data = data;
  }

  @Mutation
  SET_PAGE_META(meta: IPageMeta | null) {
    this.meta = meta;
  }

  @Mutation
  SET_PAGE_ERROR(data: IError | null) {
    this.error = data;
  }

  @Mutation
  SET_RELATED_PRODUCTS(data: IProduct[]) {
    this.relatedProducts = data;
  }

  @Action
  async getPage(params: any): Promise<void> {
    const res = await fetchPage(params);
    const { status, data } = res;

    if (status && status === 401) {
      personalModule.forceLogout();
      return;
    }

    if (status && status > 400) {
      this.SET_PAGE_ERROR({ status });
    } else {
      this.SET_PAGE_ERROR(null);
    }

    if (data.meta && data.meta.title) {
      this.SET_PAGE_DATA(data.data);
      this.SET_PAGE_META(data.meta);
      this.SET_RELATED_PRODUCTS(data.data?.related_products || []);
      document.title = data.meta.title;
      newSaleChecker(data.meta);
    } else {
      document.title = "МТК - Каталог";
    }
  }

  @Action
  resetStore() {
    this.SET_PAGE_DATA(null);
    this.SET_PAGE_ERROR(null);
    this.SET_PAGE_META(null);
    this.SET_RELATED_PRODUCTS([]);
  }
}
